import * as buttonU from './button';
import * as scaffoldingU from './scaffolding';
import * as textU from './text';
import * as helpersU from './helpers';

export const noteButtonUtils = buttonU;
export const noteScaffoldingUtils = scaffoldingU;
export const noteTextUtils = textU;
export const noteHelpers = helpersU;

export default {
  ...noteButtonUtils,
  ...noteScaffoldingUtils,
  ...noteTextUtils,
  ...noteHelpers,
};
